<div id="employment" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>

  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>

    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>

        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>

        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>

        <div class="flex box-border-active pb-4">
          <div>
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div>
            <h2 class="text-lg font-bold my-6">Employment Information</h2>
            <p *ngIf="AddAdditionalApplicantKey == null">Please provide at least two years of employment information.
              <br>By continuing, you approve Tricon contacting your employer for a Verification of Employment.
            </p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">Please provide at least
              two years of employment information for the additional applicant. <br>By continuing, you approve Tricon
              contacting the employer for a Verification of Employment.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">Please provide at least
              two years of employment information for {{AddAdditionalApplicantName}}. <br>By continuing, you approve
              Tricon contacting the employer for a Verification of Employment.</p>
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>

      <form id="employmentForm" #employmentForm="ngForm" class="flex flex-col pt-8">
        <div class="flex flex-col 2xl:flex-row mb-4"
          *ngIf="!currentEmployer || !(previousEmployers && previousEmployers.length) || !additionalIncome">
          <div>
            <button mat-button color="accent" (click)="initializeCurrentEmployer()" style="color: #545859"
              class="2xl:mr-6" *ngIf="!currentEmployer">
              ADD CURRENT EMPLOYER
            </button>
          </div>

          <div>
            <button mat-button color="accent" (click)="initializePreviousEmployers()" style="color: #545859"
              class="mt-4 2xl:mr-6 2xl:mt-0" *ngIf="!(previousEmployers && previousEmployers.length)">
              ADD PREVIOUS EMPLOYER
            </button>
          </div>

          <div>
            <button mat-button color="accent" (click)="initializeAdditionalIncome()" style="color: #545859"
              *ngIf="!additionalIncome" class="mt-4 2xl:mr-6 2xl:mt-0">
              ADD ADDITIONAL INCOME
            </button>
          </div>
          <div>
            <button mat-button color="accent" (click)="initializeCaRentVoucher()" style="color: #545859"
              *ngIf="displayCaRentVoucher()" class="mt-4 2xl:mt-0">
              CA HOUSING VOUCHER
            </button>
          </div>
        </div>

        <div *ngIf="shouldShowTabs()" class="min-h-200px">
          <mat-tab-group *ngIf="shouldShowTabs()" selectedIndex="tabIndex" #employerTabs>
            <mat-tab *ngIf="currentEmployer" dynamicHeight>
              <ng-template mat-tab-label>
                <span class="hidden sm:inline">Current Employer</span>
                <span class="sm:hidden">Current</span>
              </ng-template>
              <div class="mt-4">
                <div class="md:flex md:items-center">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Employer Name</mat-label>
                      <input matInput name="current-employer-name" id="current-employer-name" required
                        [(ngModel)]="currentEmployer.EmployerName" #EmployerName="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Industry</mat-label>
                      <mat-select name="current-employer-industry" id="current-employer-industry" required
                        [(ngModel)]="currentEmployer.RentalIndustryKey" #Industry="ngModel">
                        <mat-option *ngFor="let industry of industries" [value]="industry.value">
                          {{industry.label}}
                        </mat-option>
                      </mat-select>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Occupation</mat-label>
                      <input matInput name="current-employer-occupation" id="current-employer-occupation" required
                        [(ngModel)]="currentEmployer.Occupation" #Occupation="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Phone</mat-label>
                      <mat-input-tel name="current-employer-phone" id="current-employer-phone" required
                        [(ngModel)]="currentEmployer.PhoneNumber" required #Phone="ngModel"
                        [ngClass]="{'is-invalid': (Phone.touched || Phone.dirty) && !Phone.valid }">
                      </mat-input-tel>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Start Date</mat-label>
                      <input matInput [matDatepicker]="currentEmployerStartDatePicker"
                        name="current-employer-start-date" id="current-employer-start-date" required
                        [(ngModel)]="currentEmployer.StartDate" #StartDate="ngModel" [min]="minDate">
                      <mat-datepicker-toggle matSuffix [for]="currentEmployerStartDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #currentEmployerStartDatePicker></mat-datepicker>
                      <mat-error *ngIf="StartDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                      <mat-error *ngIf="StartDate.hasError('matDatepickerParse')">
                        "{{StartDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                      </mat-error>
                        </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>End Date</mat-label>
                      <input matInput [matDatepicker]="currentEmployerEndDatePicker" name="current-employer-end-date"
                        id="current-employer-end-date" [(ngModel)]="currentEmployer.EndDate" #EndDate="ngModel" [min]="minDate">
                      <mat-datepicker-toggle matSuffix [for]="currentEmployerEndDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #currentEmployerEndDatePicker>
                      </mat-datepicker>
                      <mat-error *ngIf="EndDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                      <mat-error *ngIf="EndDate.hasError('matDatepickerParse')">
                        "{{EndDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="md:flex ">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Supervisor's Name</mat-label>
                      <input matInput name="current-employer-supervisor" id="current-employer-supervisor" required
                        [(ngModel)]="currentEmployer.SupervisorName" #SupervisorName="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Supervisor's Phone</mat-label>
                      <mat-input-tel name="current-employer-supervisor-phone" id="current-employer-supervisor-phone"
                        required [(ngModel)]="currentEmployer.SupervisorPhoneNumber" #SupervisorPhone="ngModel">
                      </mat-input-tel>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Address</mat-label>
                      <input matInput name="current-employer-address" id="current-employer-address" required
                        [(ngModel)]="currentEmployer.Address" #Address="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Monthly Gross Income</mat-label>
                      <input matInput name="current-employer-pay" id="current-employer-pay" required
                        [(ngModel)]="currentEmployer.MonthlyPay" #MonthlyPay="ngModel" numberCeilingRounder>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Employment Status</mat-label>
                      <mat-select name="current-employment-status" id="current-employment-status" required
                        [(ngModel)]="currentEmployer.EmploymentStatusKey" #EmploymentStatusKey="ngModel">
                        <mat-option *ngFor="let status of employmentStatus" [value]="status.value">
                          {{status.label}}
                        </mat-option>
                      </mat-select>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>

              </div>

              <div>
                <button mat-button color="accent" (click)="onRemoveCurrentEmployer()" style="color: #545859"
                  class="my-4">REMOVE CURRENT EMPLOYER</button>
              </div>
            </mat-tab>

            <mat-tab *ngIf="previousEmployers && previousEmployers.length">
              <ng-template mat-tab-label>
                <span class="hidden sm:inline">Previous Employers</span>
                <span class="sm:hidden">Previous</span>
              </ng-template>
              <div
                *ngFor="let previousEmployer of previousEmployers; let i = index; trackBy:(listTrack); first as isFirst">
                <div class="mt-4">
                  <label *ngIf="previousEmployers && previousEmployers.length > 1">Previous Employer {{i + 1}}</label>

                  <div class="md:flex md:items-center">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Employer Name</mat-label>
                        <input matInput name="EmployerName[{{i}}]" id="EmployerName[{{i}}]" required
                          [(ngModel)]="previousEmployer.EmployerName" #EmployerName="ngModel">
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="md:w-1/2 md:pl-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Industry</mat-label>
                        <mat-select name="RentalIndustryKey[{{i}}]" id="RentalIndustryKey[{{i}}]" required
                          [(ngModel)]="previousEmployer.RentalIndustryKey" #Industry="ngModel">
                          <mat-option *ngFor="let industry of industries" [value]="industry.value">
                            {{industry.label}}
                          </mat-option>
                        </mat-select>
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="md:flex">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Occupation</mat-label>
                        <input matInput name="Occupation[{{i}}]" id="Occupation[{{i}}]" required
                          [(ngModel)]="previousEmployer.Occupation" #Occupation="ngModel">
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="md:w-1/2 md:pl-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Phone</mat-label>
                        <mat-input-tel name="Phone[{{i}}]" id="Phone[{{i}}]" required
                          [(ngModel)]="previousEmployer.PhoneNumber" required #Phone="ngModel"
                          [ngClass]="{'is-invalid': (Phone.touched || Phone.dirty) && !Phone.valid }"></mat-input-tel>
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="md:flex">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="previousEmployerStartDate" name="startDate[{{i}}]"
                          id="startDate[{{i}}]" required [(ngModel)]="previousEmployer.StartDate" #PrevStartDate="ngModel" [min]="minDate">
                        <mat-datepicker-toggle matSuffix [for]="previousEmployerStartDate"></mat-datepicker-toggle>
                        <mat-datepicker #previousEmployerStartDate></mat-datepicker>
                        <mat-error *ngIf="PrevStartDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                        <mat-error *ngIf="PrevStartDate.hasError('matDatepickerParse')">
                          "{{PrevStartDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="md:w-1/2 md:pl-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="previousEmployerEndDate" name="endDate[{{i}}]"
                          id="endDate[{{i}}]" [(ngModel)]="previousEmployer.EndDate" #PrevEndDate="ngModel" [min]="minDate" required>
                        <mat-datepicker-toggle matSuffix [for]="previousEmployerEndDate"></mat-datepicker-toggle>
                        <mat-datepicker #previousEmployerEndDate></mat-datepicker>
                        <mat-error *ngIf="PrevEndDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                        <mat-error *ngIf="PrevEndDate.hasError('matDatepickerParse')">
                          "{{PrevEndDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                        </mat-error>
                        </mat-form-field>
                    </div>
                  </div>
                  <div class="md:flex ">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Supervisor's Name</mat-label>
                        <input matInput name="SupervisorName[{{i}}]" id="SupervisorName[{{i}}]" required
                          [(ngModel)]="previousEmployer.SupervisorName" #SupervisorName="ngModel">
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="md:w-1/2 md:pl-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Supervisor's Phone</mat-label>
                        <mat-input-tel name="SupervisorPhone[{{i}}]" id="SupervisorPhone[{{i}}]" required
                          [(ngModel)]="previousEmployer.SupervisorPhoneNumber" #SupervisorPhone="ngModel">
                        </mat-input-tel>
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="md:flex">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Address</mat-label>
                        <input matInput name="Address[{{i}}]" id="Address[{{i}}]" required
                          [(ngModel)]="previousEmployer.Address" #Address="ngModel">
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="md:w-1/2 md:pl-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Monthly Gross Income</mat-label>
                        <input matInput name="MonthlyPay[{{i}}]" id="MonthlyPay[{{i}}]" required
                          [(ngModel)]="previousEmployer.MonthlyPay" #MonthlyPay="ngModel" numberCeilingRounder>
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="md:flex">
                    <div class="md:w-1/2 md:pr-2">
                      <mat-form-field class="w-full my-2">
                        <mat-label>Employment Status</mat-label>
                        <mat-select name="EmploymentStatusKey[{{i}}]" id="EmploymentStatusKey[{{i}}]" required
                          [(ngModel)]="previousEmployer.EmploymentStatusKey" #EmploymentStatusKey="ngModel">
                          <mat-option *ngFor="let status of employmentStatus" [value]="status.value">
                            {{status.label}}
                          </mat-option>
                        </mat-select>
                        <mat-error>Please fill out this field</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div>
                  <button mat-button color="accent" (click)="onRemovePreviousEmployer(i)" style="color: #545859"
                    class="my-4">REMOVE PREVIOUS EMPLOYER<span
                      *ngIf="previousEmployers && previousEmployers.length > 1"> {{i + 1}}</span></button>
                </div>
              </div>

              <div>
                <button mat-button color="accent" (click)="addAdditionalPreviousEmployer()" style="color: #545859"
                  class="my-4">ADD ADDITIONAL EMPLOYER</button>
              </div>
            </mat-tab>

            <mat-tab *ngIf="additionalIncome">
              <ng-template mat-tab-label>
                <span class="hidden sm:inline">Additional Income</span>
                <span class="sm:hidden">Add. Income</span>
              </ng-template>

              <div class="mt-4">
                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Additional Income</mat-label>
                      <input matInput name="additional-income-amount" id="additional-income-amount"
                        [(ngModel)]="additionalIncome.AdditionalIncomeAmount" #Amount="ngModel" required
                        numberCeilingRounder>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="md:w-1/2 md:pl-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Additional Income Source</mat-label>
                      <input matInput name="additional-income-source" id="additional-income-source"
                        [(ngModel)]="additionalIncome.AdditionalIncomeSource" required #Source="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div>
                <button mat-button color="accent" (click)="onRemoveAdditionalIncome()" style="color: #545859"
                  class="my-4">REMOVE ADDITIONAL INCOME
                </button>
              </div>
            </mat-tab>
            <mat-tab *ngIf="editCaRentVoucher()">
              <ng-template mat-tab-label>
                <span class="hidden sm:inline">CA Housing Voucher</span>
                <span class="sm:hidden">Add. Income</span>
              </ng-template>
              <div class="mt-4">
                <div class="md:flex">
                  <div class="md:w-1/2 md:pr-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>CA Housing Voucher Amount</mat-label>
                      <input matInput name="ca-housing-voucher-amount" id="ca-housing-voucher-amount"
                        [(ngModel)]="caVoucherAmount" #CaVoucherAmount="ngModel" required
                        numberCeilingRounder>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div>
                <button mat-button color="accent" (click)="onRemoveCaRentVoucher()" style="color: #545859"
                  class="my-4">REMOVE CA HOUSING VOUCHER
                </button>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="md:flex md:items-center w-full mt-2">
          <div class="mr-2" *ngIf="!navigateToVerifast && (currentEmployer || additionalIncome)">
            <label class="mat-input-button" style="padding: 0.5rem; height: 2.5rem;">
              <span>Upload Proof of Income</span>
              <input type="file" class="hidden" (change)="uploadFiles($event)">
            </label>
          </div>

          <div class="text-right flex-1">
            <button mat-flat-button color="primary" (click)="cancelEdit()" class="h-10 px-6 my-2"
              *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>
            <button mat-flat-button color="primary" (click)="checkEmploymentHistory()" class="h-10 px-6 my-2 ml-2"
              [disabled]="!employmentForm.valid || disableSubmitBtn">CONTINUE</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
